import { render, staticRenderFns } from "./LegacyDomainRegistrationWizard.vue?vue&type=template&id=c0595518&"
import script from "./LegacyDomainRegistrationWizard.vue?vue&type=script&lang=js&"
export * from "./LegacyDomainRegistrationWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports